"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var React = require("react");

var palette_1 = require("../constants/palette");

var spin = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n 0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"], ["\n 0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
var StyledLoader = styled_components_1.default.section(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  height: 28px;\n  width: 28px;\n  margin: 2px 8px -10px;\n  border: 4px solid transparent;\n  border-top: 4px solid ", "; // TODO: change color to theme color\n  border-radius: 100%;\n  animation: ", " 1.5s linear infinite;\n"], ["\n  display: inline-block;\n  height: 28px;\n  width: 28px;\n  margin: 2px 8px -10px;\n  border: 4px solid transparent;\n  border-top: 4px solid ", "; // TODO: change color to theme color\n  border-radius: 100%;\n  animation: ", " 1.5s linear infinite;\n"])), palette_1.default.darkOrange, spin);

var Loader = function Loader(props) {
  return React.createElement(StyledLoader, null);
};

exports.default = Loader;
var templateObject_1, templateObject_2;